import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router';

import {
	selectIsAuthenticated,
	selectIsLoadingUser,
	selectRefreshToken,
} from '@shared/api/reduxToolkit';
import { PATHS } from '@shared/constants';

export const PrivateRoute = () => {
	const isAuth = useSelector(selectIsAuthenticated);
	const isLoadingUser = useSelector(selectIsLoadingUser);
	// Needed to detect startup refresh in progress (see isInitializing below)
	const refreshToken = useSelector(selectRefreshToken);

	// On page reload accessToken is null (lives in memory only, not persisted).
	// refreshToken IS restored from sessionStorage by redux-persist.
	// AuthInitializer detects this and fires a silent /v1/user/refreshToken request.
	// Without this guard PrivateRoute would see isAuth=false and redirect to /auth immediately,
	// losing the current URL and eventually landing on user-profile instead of the original page.
	const isInitializing = Boolean(refreshToken) && !isAuth;

	// Wait for AuthInitializer to finish — render nothing while refresh is in flight
	if (isInitializing) return null;

	if (isAuth && isLoadingUser) return null;

	if (!isAuth) return <Navigate to={PATHS.HOME} replace />;

	return <Outlet />;
};
